import { render, staticRenderFns } from "./b-ticket-personal-details.vue?vue&type=template&id=bf0f40e2&scoped=true"
import script from "./b-ticket-personal-details.vue?vue&type=script&lang=ts"
export * from "./b-ticket-personal-details.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-personal-details.vue?vue&type=style&index=0&id=bf0f40e2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0f40e2",
  null
  
)

export default component.exports